/**
 * Наблюдает за пересечением элементов, соответствующих заданному селектору, с областью видимости и вызывает заданную функцию обратного вызова при каждом пересечении.
 *
 * @param {string} selector - Селектор для выбора элементов, которые нужно наблюдать.
 * @param {Function} callback - Функция обратного вызова, которая будет вызвана при пересечении наблюдаемых элементов с областью видимости.
 * @param {Object} [options={}] - Дополнительные настройки для IntersectionObserver.
 */

export function observeIntersection(selector, callback, options = {}) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        callback(entry.target);
      }
    });
  }, options);

  const elements = document.querySelectorAll(selector);
  elements.forEach((element) => observer.observe(element));

  return observer;
}
